import { atom, selector } from 'recoil';

export const userStatusAtom = atom({
	key: 'userStatusOnlineKey',
	default: {
		status: null,
		location: null,
		role: null,
		handRaised: false,
		connectionStatus: 0,
		connections: [] as CompressedUser[],
		userMode: '',
		isMobile: false,
	},
});

export const availableClassesState = atom({
	key: 'availableClassesState',
	default: [],
});

export const roleSelector = selector({
	key: 'roleSelectorKey',
	get: ({ get }) => {
		const userStatusOnline = get(userStatusAtom);
		return userStatusOnline.role;
	},
	cachePolicy_UNSTABLE: {
		eviction: 'most-recent',
	},
});

export const handRaisedSelector = selector({
	key: 'handRaisedSelectorKey',
	get: ({ get }) => {
		const userStatusOnline = get(userStatusAtom);
		return userStatusOnline.handRaised;
	},
	cachePolicy_UNSTABLE: {
		eviction: 'most-recent',
	},
});

export const connectionsSelector = selector({
	key: 'connectionsSelectorKey',
	get: ({ get }) => {
		const userStatusOnline = get(userStatusAtom);
		return userStatusOnline.connections;
	},
	cachePolicy_UNSTABLE: {
		eviction: 'most-recent',
	},
});

export const locationSelector = selector({
	key: 'userLocationSelectorKey',
	get: ({ get }) => {
		const userStatusOnline = get(userStatusAtom);
		return userStatusOnline.location;
	},
	cachePolicy_UNSTABLE: {
		eviction: 'most-recent',
	},
});

export const hybridSelector = selector({
	key: 'hybridSelectorKey',
	get: ({ get }) => {
		const userStatusOnline = get(userStatusAtom);
		return userStatusOnline.userMode === 'hybrid';
	},
	cachePolicy_UNSTABLE: {
		eviction: 'most-recent',
	},
});

export const statusSelector = selector({
	key: 'statusSelectorKey',
	get: ({ get }) => {
		const userStatusOnline = get(userStatusAtom);
		return userStatusOnline.status;
	},
	cachePolicy_UNSTABLE: {
		eviction: 'most-recent',
	},
});
